import React from 'react';

export default function RequiredMark() {
    return <span style={{ color: 'red' }}>*</span>;
}
